/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import { SpinnerProps } from "@nordcloud/gnui/dist/components/spinner/Spinner";
import {
  ResourceComplianceStatus,
  ResourceUpdateStatus as GQResourceUpdateStatus,
} from "~/generated/graphql";
import { SvgName } from "~/tools/types";

export type ResourceUpdateStatus =
  typeof ResourceUpdateStatus[keyof typeof ResourceUpdateStatus];

export const ResourceUpdateStatus = {
  Failed: GQResourceUpdateStatus.Failed,
  InProgress: GQResourceUpdateStatus.InProgress,
  NoPendingUpdates: GQResourceUpdateStatus.NoPendingUpdates,
  NoUpdatesData: GQResourceUpdateStatus.NoUpdatesData,
  PendingUpdates: GQResourceUpdateStatus.PendingUpdates,
  Total: "TOTAL",
} as const;

export type UpdateStatusCardItem = {
  status: ResourceUpdateStatus;
  count: number;
};

export type StatusDetail = {
  label: string;
  color: string;
  icon: SvgName;
  spinnerColor: SpinnerProps["color"];
};

export type ComplianceStatus = ResourceComplianceStatus | "N/A";

export type ComplianceStatusDetail = {
  label: string;
  iconColor: string;
  icon?: SvgName;
  tooltip: string;
  uiStatus?: "success" | "danger";
  disabled?: boolean;
};
